<template>
    <basicSearch :onSearchApi="onSearchApi" placeholder="搜索" v-bind="$attrs" v-on="$listeners"></basicSearch>
</template>

<script>

import basicSearch from '@/components/basic/search.vue';
import { searchRune } from '@/api/games/rune';


export default {
    name: "rune-search",
    components: {
        basicSearch
    },
    data () {
        return {
            onSearchApi: searchRune,
        }
    }
}
</script>
